// components/YouMessage.tsx — ported from docs/superpowers/design-2026-04-21/messages.jsx

import type { JSX, ReactNode } from 'react';
import { useTokens } from '../state/theme';

export interface YouMessageProps {
  children: ReactNode;
}

export function YouMessage({ children }: YouMessageProps): JSX.Element {
  const tokens = useTokens();
  return (
    <div className="asc-fade-in" style={{
      display: 'flex', justifyContent: 'flex-end', marginTop: 10,
    }}>
      {/* Redesign §3.3 / V4: the user bubble is one of the "five moments of
          color" — brand gradient, white text, asymmetric corner, soft violet
          glow. White text reads on the saturated gradient in both modes. */}
      <div style={{
        maxWidth: '80%',
        background: tokens.brandGradient, color: '#fff',
        padding: '11px 16px', borderRadius: '16px 16px 4px 16px',
        fontFamily: tokens.fonts.body, fontSize: 15, lineHeight: 1.45, fontWeight: 500,
        boxShadow: tokens.mode === 'dark'
          ? '0 6px 22px rgba(124,90,255,0.30)'
          : '0 6px 22px rgba(105,67,255,0.22)',
      }}>{children}</div>
    </div>
  );
}
